import { useSyncExternalStore } from 'react'
import { subscribe, getTheme, getResolvedTheme } from './theme'

// getTheme is the user's choice (may be "system"); getResolvedTheme is the
// appearance actually in force, which is what anything picking colours in JS
// needs.
export function useTheme() {
  return useSyncExternalStore(subscribe, getTheme, () => 'system')
}

export function useResolvedTheme() {
  return useSyncExternalStore(subscribe, getResolvedTheme, () => 'light')
}
